import {EncryptionService, InitializerService} from '@atumverse/core-services';
import { InjectService } from '../services/inject.service';
import * as echarts from 'echarts';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export function initFInfra (
  appInitializeService: InitializerService,
  injectService: InjectService,
  encryptionService: EncryptionService,
  httpClient: HttpClient
) {
  return (async () => {
    const rsaPrivateKey = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDBOPsCvDe34fuUpkvhKXiD6zGIwzRrlbFC9PgHoVx52eFMniM5iD9c6ZEaouW0TYvI49k+ZqCrdJvCf76JttnQuNp/xxOCK6BJIzqkyVFB6jitXec3vQM1nzE/2123x5xMIws1zDOLDA0RlrmKPlZQXObF1eUo9+VDvOFqDOMOW2D11vFalBO14cnpiTLWvx8lX2WW6+y7XgMn9pBDe+du2M4N1I1/5OaqKV4g6kIL+mzSQU4V+IxapQpg883m8Lo8fZ4z73KEIVPOnu4ILf5KvV0Ss5ChvdKPZ4VrEHGHjjmLb2g1rYTLF/ulICSRY6NT/v3675y2iU4Pr/y/jcDbAgMBAAECggEBALEtjcY5TyJXnzj0sHm8bF0TCq3syaGpdwz90n40sbauWtDF5Wj5DZkmN79kBhwqS3afr/Jvav8tgzJ7rv1a5Spmhz1KEBJ57JWEL18xl0hI/UXD6KSMtmeyHRgAEFTYPfL2422mXNEw8L7jJimk9cLlHVvlwieqANn3Vf/H52CeRCxOfPXspe44oiaPBOIsEnlSjn23KBTabcLBPAaF80+DnetVf4IqGmVQmtmagzZDzrlibhlIig3KZ6h95NuNvG7gB++BS86QwZYNS3056jCapdWtUYnb4kJQG7L/yZSNrFGXfwGqIJOJ6r/NCzGnXy1Ot+/mYXX7L+U06lPcwYkCgYEA5BI73w1CdWvVP3+uj0yMqgX841MhfaCVImY1muQJXw5H+lyi6dRBsOnkKlc/wKQmFeDKliozMtysJqOTiY2pl5ykV1WYR8ci84UJrqr+QMAWFGydh4amSUtg6uozcjDdUEfszOGvKqAzPAwRzsZxHnLt/Ns8v1tUR2Hj/sIiJt8CgYEA2OJISHTnV6fyssrfgHRNIWEemRRtGq+LEXFVv/4nt2ee1xiWxULpzHpj+9mO6i3nJ97Jn3un0pd7ohpy33JCgTjNsvzAR3jWNoLd3kyqL5GpZisshL2j5m3rqepR39ojbUyCB3PncPsZcUNshrpPV+4J0AaND4LUhbiKilndUYUCgYAkvgNDNeGlBRA/wJQgpdZrdbd97+CPWpVsC0dLgr03wRc7cD0WqolCtQt6/r9Yi5lPIP3CH15MLVzWhLe6C0ZtFGEtaK61sZEh5ibfKtD3IXrtI2plcP3NBQXCEqTjGpgs3Ml7YEhV96UJYXBk/XcvzpgkijVJJq93KIAQhLn3xQKBgQDUFCmkmJQj1fnwNYtqG8/UZRi7jgrGPoPZsZ6tWETUBkJ/iO7dw/nFVqTwgCRNAEf6Z9N23T8VIcXmlMBhmWRI4hfa/2ayPQoTUdLM7uC4FVK1smAdCSf9St1YUOZw4+kilt7LlN3rT87oP4sfD45IqF72CYHkegWBIRxv/0H41QKBgDnnMpNVZQJlil6Hio8btBNK5aTSdIMx0EPvsYRiokiY+eHqH+Kda6pYb64fPRHyGQRTMt7Wst6zs+LmNrb3+8juGq/xaWl/U07cBips+Gf+qaLhPw9PA9vqh/h9nroUwynrOIKKjPMcC1za6KIy6tywYjOkPQ3pSEMnJvUjGl02';
    const iv = 'iQv5Uw6iijvTgmZO3wDntPhhf+0TLYsrE0Pyw/qRnvnOQLafHDOVVlk1BIqpg0+uFrvfd1XSVqNO68xZNhDcRNtePDnb6DRP1B7F7ttJIy9kwCR37H/ClHNFgueEvrr5xpvA/S0d+ysbtxx4twKxscbssmRc9hlYC07VDLKLoHSQk9A7iBk6zejsIzu+ERde1WOAISX8JBdlXxzJh8Ephig4U7hbbcsnSKIQqUGTdvf50vf+2jy1qXRRbFHyG9kaow2Uz2f94tC6DLLHNdn1ewECNLgXxp+uNLIV7jUPKnDUe/uLeVxfd2jD1DTYRemVFIPSUvJAf4BM6UnPE15tUw==';
    const aesKey = 'dJtQDqwAS3WPykuTsCuCEeEk8Dk5X5iaLZ0kUk145M+TDeAMa0wzkdnfjxBFt27rSOv23ktEt76s+DTn+yjDB3D8q7u9aZBg/LU1yxWoW1GTsVG8nochKpeHxbeRBCg7c8FbJI0xBGtd752IKY+DZAO5wMAWuQKXPeeLRDXC2yNiewVOsPu4FN85E/YukpAWaLYpkmS20kqqV+bvwdSaIsBXKUyvbgsMQ0mAukGzLz19+MKPFkwFBBrzS2WVB/mHfUtaBuxwrF0VeC89Yw1wj8/63mtxtin4OXLS5qqizSNFwJA54XeoKwNKV9zfK7Fvck4MPQyLB6LcnbFKW0U1tA==';
    const iamAesKey = 'rBcd0uRUfOxWYs2K8BcyIOE5H87pnsQdNoXGgiMttbm6n6C32IF8dfgkTpqPZlfzXhvehlL+7JnMiKk7XKhn1rIWl8UR0r1AL/ItywK1OQ2F68idTGd3s44Axjn/SX8Jb8HLgrn6JVf0q4K8EtSjAfSTv+HH0WyXf+sYieVEPIPSdLHpvXqOQfh03V8/Xv2STtvbXnAZs9fSm6QF32CvOzZ1V4uwRpOzBBU5HV/ZDRsd8G1nuEIo9OQZeBw3bngkKvI/sTPXyM31gZiTgkVosHYdOzNawuXWHSNAej/G9AuwlPvib+UcBNJazQZ+lbwgIYknX0XWl/tzZPeeyICAiw==';


    injectService.initialize();
    await encryptionService.init(rsaPrivateKey, null, iv, aesKey, 'assets');
    encryptionService.importIv('message', new Uint8Array(16));

    encryptionService.importAESKeyEncrypted(iamAesKey, 'iam');
    encryptionService.importIv('iam', new Uint8Array(16));

    const options: any = {
      responseType: 'arraybuffer',
      observe: 'response',
    };

    if (!environment.production) {
      options.responseType = 'application/json';
    }

    let echartsTheme: any = await httpClient.get('assets/configs/application-configs/echarts-theme-light.json', options).toPromise();
    let echartsDarkTheme: any = await httpClient.get('assets/configs/application-configs/echarts-theme-dark.json', options).toPromise();

    if (environment.production) {
      echartsTheme = await encryptionService.decryptAES(echartsTheme.body, 'assets');

      if (echartsTheme) {
        echartsTheme = JSON.parse(echartsTheme);
      }

      echartsDarkTheme = await encryptionService.decryptAES(echartsDarkTheme.body, 'assets');

      if (echartsDarkTheme) {
        echartsDarkTheme = JSON.parse(echartsDarkTheme);
      }
    } else {
      echartsTheme = JSON.parse(echartsTheme.body);
      echartsDarkTheme = JSON.parse(echartsDarkTheme.body);
    }

    echarts.registerTheme('finfra-echarts-theme', echartsTheme);
    echarts.registerTheme('finfra-echarts-dark-theme', echartsDarkTheme);

    const response: any = await httpClient.get('assets/configs/globalConfig.json', options).toPromise();

    let globalConfig: any;
    if (environment.production) {
      globalConfig = {
        default: await encryptionService.decryptAES(response.body, 'assets'),
      };
    } else {
      globalConfig = {
        default: response.body,
      };
    }

    if (globalConfig && globalConfig.default) {
      globalConfig.default = JSON.parse(globalConfig.default);

      if (!environment.production) {
        globalConfig.default.encryptedAssetJsons = false;
      }

      const result = await appInitializeService.initialize(globalConfig);
      return result;
    }

    return false;
  });
}
